export function formatFormGuide(data) {
  if (!data?.clubs) {
    return [];
  }

  return data?.clubs.map((club) => {
    return {
      competitionName: data?.competitionName,
      competitionSlug: data?.competitionSlug,
      matchType: data?.matchType,
      season: data?.season,
      slug: club?.slug,
      rank: club?.rank,
      logoColorUrl: club?.logoURL,
      abbr: club?.abbr,
      matches: club?.matches,
      sportecId: club?.sportecId,
      shortName: club?.shortName,
      fullName: club?.fullName
    };
  });
}

export function getMatchColumnsLength(clubs) {
  if (!clubs) {
    return 0;
  }

  let matchesLength = 0;

  clubs.forEach((club) => {
    if (club?.matches?.length > matchesLength) {
      matchesLength = club?.matches?.length;
    }
  });

  return matchesLength;
}
